import React from 'react';
import PropTypes from 'prop-types';

import styles from './DurationPicker.scss';
import TextField from './TextField';
import DropDownList from './DropDownList';

import {TIME_UNITS} from 'sources/constants/timeUnits';

DurationPicker.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.shape({
    count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    unit: PropTypes.oneOf(TIME_UNITS),
  }),
  disabled: PropTypes.bool,
  error: PropTypes.string,
};

DurationPicker.defaultProps = {
  value: {},
};

export default function DurationPicker(props) {
  const {value, onChange, disabled, error} = props;

  const handleChangeCount = e => {
    const {target: {value: val}} = e;
    const {value} = props;

    const newValue = {
      ...value,
      count: val,
    };

    onChange({target: {value: newValue}});
  }

  const handleChangeUnit = e => {
    const {target: {value: val}} = e;
    const {value} = props;

    const newValue = {
      ...value,
      count: 1,
      unit: val,
    };

    onChange({target: {value: newValue}});
  }

  return (
    <div className={styles.container}>
      <TextField
        value={value.count}
        onChange={handleChangeCount}
        className={styles.field}
        disabled={disabled}
        type='number'
        error={error}
      />
      <DropDownList
        value={value.unit}
        items={TIME_UNITS}
        formatter={loc}
        onChange={handleChangeUnit}
        headerClassName={styles.field}
        customClassName={styles.field}
        disabled={disabled}
        error={error}
      />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/controls/DurationPicker.jsx